<se-fe-page>
  <se-fe-header
    seFePageHeader
    seFeDataTitle="Add Guardian"
    seFeDataSubtitle="Add a guardian"
    size="750">
  </se-fe-header>

  <div seFePageContent>
    <div class="docs-content">
      <se-fe-card>
        <se-fe-card-header seFeDataTitle="When to use"></se-fe-card-header>
        <se-fe-card-content>
          <p>Use this for sending a guardian invite</p>
        </se-fe-card-content>
      </se-fe-card>

      <se-fe-card class="form-example">
        <se-fe-card-header seFeDataTitle="Add a Guardian example"></se-fe-card-header>
        <se-fe-card-content>
          <se-po-add-guardian-example></se-po-add-guardian-example>
        </se-fe-card-content>
      </se-fe-card>
    </div>
  </div>
</se-fe-page>
